const CONFIG = {
  workspace_id: '7633222766753',
  pa_token: '0/50e4bd48ef742cf5c4ca65cc2707d1f0',
  projects_id: '1120691940870388',
  assignee_id: '1122519697718712',

  fieldInterface: {
    cost: {
      id: '1127907098602421'
    },
    invoice_status: {
      id: '1120692468866974',
      options: {
        is_invoiced: '1120692468866975',
        not_invoiced: '1120692468866976',
        unsure: '1120692468866977'
      }
    },

    priority: {
      id: '1124734387184531',
      options: {
        low: '1124734387184532',
        medium: '1124734387184533',
        high: '1124734387184534'
      }
    }
  }
};

export function getTaskPayload(taskID) {
  return {
    async: true,
    crossDomain: true,
    url: `https://app.asana.com/api/1.0/tasks/${taskID}`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${CONFIG.pa_token}`,
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: {
      workspace: CONFIG.workspace_id
    }
  };
}
